import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as pipes from '../../pipes'
import { ListStore } from '../store'
/** TODO */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [pipes.FormattedDateRangePipe, ngCommon.NgClass],
  selector: 'atn-ds-date-multi-range-input',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Reference to container element which is wrapping all ranges */
  public readonly selectedRangesContainerRefSg =
    ngCore.viewChild<ngCore.ElementRef<HTMLElement>>('containerRef')

  /** Reference to all selected ranges  */
  public selectedRangesRefSg =
    ngCore.viewChildren<ngCore.ElementRef<HTMLElement>>('selectedItemRef')

  /** @see {@link ListStore} */
  public readonly listStore = ngCore.inject(ListStore)

  /** @see {@link ds.Legacy} */
  public readonly PredefinedStyleEnum = ds.color.Legacy.PredefinedStyle

  /**
   * Indicates whether the list of selected ranges is expanded (fully shown) or
   * collapsed.
   */
  public readonly expandedSg = ngCore.signal(false)

  /**
   * If we have more items then can fit in the select, we show the expand
   * button.
   */
  public readonly showExpandButtonSg = ngCore.computed(() => {
    const selectedRangesRef = this.selectedRangesRefSg()
    const selectedRangesContainerRef = this.selectedRangesContainerRefSg()
    const childrenWidth =
      selectedRangesRef?.reduce(
        (prev, curr) => prev + curr.nativeElement.offsetWidth,
        0,
      ) ?? 0
    const offsetWidth =
      selectedRangesContainerRef?.nativeElement.offsetWidth ?? 0
    return childrenWidth > offsetWidth
  })

  /** Handles click events on the "Show/Hide" button.  */
  public toggleExpandButtonClickHandler(): void {
    this.expandedSg.update(expanded => !expanded)
  }
}
